import { Component, input } from "@angular/core";

@Component({
  selector: "app-character-count",
  standalone: true,
  templateUrl: "./character-count.component.html",
  styleUrl: "./character-count.component.scss"
})
export class CharacterCountComponent {
  current = input.required<number>();
  max = input.required<number>();
}
